import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import PersonPhoto from "~/components/PersonPhoto";
import { PERSONS_KEYS } from "~/persons/makuderovi";
import { ROUTES } from "~/const-files/const";
import { getClassName } from "~/utils/utils";

import "./style.less";

export interface IFirstDayKid {
	key: string;
	name: string;
}

// 1. 9. 2026 mel prvni den Martinek, pak se kluci kazdy den stridaji
const START_DATE = dayjs("2026-09-01");
const KIDS: Array<IFirstDayKid> = [{
	key: PERSONS_KEYS.MAR_MAK,
	name: "Martínek",
}, {
	key: PERSONS_KEYS.TOM_MAK,
	name: "Tomášek",
}];

export function getFirstDayKid(date: dayjs.Dayjs) {
	const diff = date.startOf("day").diff(START_DATE, "day");
	// i pro data pred startem (zaporny rozdil)
	const ind = ((diff % KIDS.length) + KIDS.length) % KIDS.length;

	return KIDS[ind];
}

export function FirstDayKidPhoto({ kid, className }: { kid: IFirstDayKid; className: string; }) {
	// fotka z portretu osoby (persons-portraits)
	return <PersonPhoto person={{ key: kid.key, fullName: kid.name, photoBest: null }} fullName={false} noClick={true} className={className} />;
}

interface IFirstDayToday {
	variant: "page" | "header";
}

export default function FirstDayToday({
	variant,
}: IFirstDayToday) {
	const navigate = useNavigate();
	const today = dayjs();
	const todayKid = getFirstDayKid(today);
	const isHeader = variant === "header";

	return <div
		className={getClassName(["firstDayToday", `firstDayToday--${variant}`])}
		onClick={isHeader ? () => navigate(ROUTES.FIRST_DAY) : undefined}
		title={isHeader ? `Dnes má první den ${todayKid.name}` : undefined}
	>
		<span className="firstDayToday__label">Dnes má první den</span>
		<FirstDayKidPhoto kid={todayKid} className="firstDayToday__photo" />
		<span className="firstDayToday__name">{ todayKid.name }</span>
		<span className="firstDayToday__date">{ today.format(isHeader ? "dddd D. M." : "dddd D. MMMM YYYY") }</span>
	</div>;
}
